export const pageTitle = (title) => (title ? `${title} | Nave` : 'Nave');